<div mat-dialog-content>
  <p> Upload image file for <span class="school-name">{{this.school?.fullName}}</span> </p>
</div>

<div mat-dialog-actions>
  <app-upload-file class="form-control" [modelId]="school?.id" model="schools" field="mainLogo"
      [(ngModel)]="school.mainLogo" [ngModelOptions]="{standalone: true}" ></app-upload-file>
</div>
